import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  TextField,
  MenuItem,
  Button,
  Card,
  CardContent,
  Typography,
  IconButton,
  Box,
  Grid,
  TextareaAutosize,
  Autocomplete,
} from "@mui/material";
import styled from "@emotion/styled";
import {
  createStabilimento,
  fetchSingleStabilimento,
  fetchStabilimenti,
  fetchTipologia,
  updateSingleStabilimento,
} from "../../../features/stabilimenti/stabilimentiThunk";
import { useDispatch, useSelector } from "react-redux";
import { fetchCities, fetchProvincies, fetchRegions } from "../../../features/region/regionThunk";
import { selectCities } from "../../../features/region/regionSlice";
import { fetchCantines } from "../../../features/cantine/cantineThunk";
import { selectCantines } from "../../../features/cantine/cantineSlice";
const Textarea = styled(TextareaAutosize)`
    box-sizing: border-box;
    width: 100%;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 12px;
    border-radius: 5px;
    color: #160A2A;
    background: #fff;
    border: 2px solid #e5e5e5;
`;

// Updated EmptyTextarea Component
const EmptyTextarea = ({ placeholder, value, onChange }) => {
  const [inputValue, setInputValue] = useState(value || "");

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  const handleChange = (event) => {
    setInputValue(event.target.value);
    onChange(event);
  };

  return (
    <Textarea
      aria-label="empty textarea"
      placeholder={placeholder}
      minRows={4}
      value={inputValue}
      onChange={handleChange}
    />
  );
};
const dmsRegex = /^(\d{1,2}°\d{2}'\d{2}"[NS])\s(\d{1,3}°\d{2}'\d{2}"[EW])$/;
const schema = yup.object().shape({
  nome: yup.string().required("Nome dello stabilimento is required"),
  tipologia: yup.string().required("Tipo di stabilimento is required"),
  superficie_totale: yup.string().matches(
    /^[0-9]+([,][0-9]+)*([.][0-9]+)?$/, // Allow numbers, commas, and dots
    "La superficie totale deve essere un numero valido con il punto"
  ),
  superficie_coperta: yup.string().matches(
    /^[0-9]+([,][0-9]+)*([.][0-9]+)?$/, // Allow numbers, commas, and dots
    "La superficie totale deve essere un numero valido con il punto"
  ),
  capacita_stoccaggio: yup
    .string()
    .required("Superficie Stoccaggio is required"),
  presenza_impianti_speciali: yup
    .boolean()
    .oneOf([true, false], "Impianti must be true or false")
    .required("Impianti is required"),
  coordinate_gps: yup
    .string()
    .required("Coordinate GPS sono richieste")
    .matches(
      dmsRegex,
      "Le coordinate GPS devono essere nel formato DMS: 41°45'09\"N 13°38'16\"E"
    ),
  comune: yup.string().required("Comune is required"),
  cap: yup.string()
    .required("CAP is required")
    .matches(/^\d{5}$/, "CAP must be exactly 5 digits"),
  provincia: yup.string().required("provincia is required"),
  regione: yup.string().required("Regione is required"),
  cantina: yup.mixed(),

});
const options = ["Amministratore", "Collaboratore", "Operatore"];

const StabilimentiForm = ({ cantine, setCantine, cantineSingleData, singleData }) => {
  const dispatch = useDispatch();
  const [tipologiaOptions, setTipologiaOptions] = useState([]);
  const cities = useSelector(selectCities);
  const { provincies, regions } = useSelector((state) => state.region);
  const CantineData = useSelector(selectCantines)

  // console.log("hiby", provincies);
  // console.log("by", regions);

  // console.log("tipologiaOptions", tipologiaOptions);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      nome: "",
      tipologia: null,
      superficie_totale: "",
      superficie_coperta: "",
      capacita_stoccaggio: "",
      presenza_impianti_speciali: "",
      coordinate_gps: "",
      comune: "",
      cap: "",
      provincia: "",
      regione: "",
      note: "",
      cantina: "",

    },
  });
  console.log("errors1", errors);
  console.log("canta12", singleData);

  useEffect(() => {
    if (!regions || regions.length === 0) {
      dispatch(fetchRegions());
    }
    if (!provincies || provincies.length === 0) {
      dispatch(fetchProvincies());
    }
    if (!cities || cities.length === 0) {
      dispatch(fetchCities());
    }
    console.log(cantineSingleData, 'skdjnsj');

    dispatch(fetchTipologia())
      .unwrap()
      .then((response) => {
        setTipologiaOptions(response?.data || []);
      })
      .catch((error) => {
        console.error("Error fetching tipologia:", error);
      });
    dispatch(fetchCantines())
    if (!cantine) {
      const formattedData = {
        ...singleData,
        cantina: typeof singleData?.cantina_id === 'object'
          ? singleData?.cantina_id
          : CantineData.find(c => c.id === singleData?.cantina_id) || null,

      };


      reset(formattedData);
    }
    // dispatch(fetchCities())
    // reset(singleData);
  }, [dispatch, cantine, singleData, reset]);

  const onSubmit = async (data) => {
    try {
      const cantinaId = data.cantina?.id;
      const StablimintData = {
        nome: data.nome,
        tipologia: data.tipologia,
        superficie_totale: data.superficie_totale,
        superficie_coperta: data.superficie_coperta,
        capacita_stoccaggio: data.capacita_stoccaggio,
        presenza_impianti_speciali: data.presenza_impianti_speciali,
        coordinate_gps: data.coordinate_gps,
        comune: data.comune,
        cap: data.cap,
        provincia: data.provincia,
        regione: data.regione,
        note: data.note,
        cantina_id: cantinaId,

      };
      // console.log("dataatine1", data);

      if (singleData) {
        console.log("Updating cantine with ID:", singleData?.id);
        await dispatch(
          updateSingleStabilimento({ StablimintiId: singleData?.id, StablimintData })
        ).unwrap();

        dispatch(fetchSingleStabilimento(singleData?.id));
        console.log("Stabiliment updated successfully!");
      } else {

        await dispatch(createStabilimento(StablimintData)).unwrap();
        dispatch(fetchStabilimenti());
        setCantine(false)
        // console.log("Stabiliment created successfully!");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };


  return (
    <>
      <form className="AziendaFrom" onSubmit={handleSubmit(onSubmit)}>
        <div className="AziendaFrom__inner">

          {!cantine && <Typography mb={"10px"}>ID=0001</Typography>}


          {((singleData?.cantina_id !== null)) && (
            !cantineSingleData && (
              <Controller
                defaultValue={null}
                name="cantina"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    options={CantineData}
                    getOptionLabel={(option) => option.name || ''}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="cantina"
                        className="customTextBox autoCompleteTextBox"
                        margin="normal"
                        fullWidth
                        error={!!errors.cantina}
                        helperText={errors.cantina?.message}
                      />
                    )}
                    onChange={(_, value) => field.onChange(value)}
                    value={field.value || null}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                  />
                )}
              />
            )
          )}

          <Controller
            defaultValue=""
            name="nome"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                label="Nome dello stabilimento"
                fullWidth
                margin="normal"
                error={!!errors.nome}
                helperText={errors.nome?.message}
              />
            )}
          />
          <Controller
            defaultValue=""
            name="tipologia"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={tipologiaOptions}
                onChange={(event, value) => field.onChange(value)} // To handle selected value properly
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipo di stabilimento"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.tipologia}
                    helperText={errors.tipologia?.message}
                  />
                )}
              />
            )}
          />

          <Controller
            defaultValue=""
            name="superficie_totale"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                label="Superficie Totale"
                fullWidth
                margin="normal"
                error={!!errors.superficie_totale}
                helperText={errors.superficie_totale?.message}
              />
            )}
          />
          <Controller
            defaultValue=""
            name="superficie_coperta"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                label="Superficie Coperta"
                fullWidth
                margin="normal"
                error={!!errors.superficie_coperta}
                helperText={errors.superficie_coperta?.message}
              />
            )}
          />
          <Controller
            defaultValue=""
            name="capacita_stoccaggio"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                label="Superficie Stoccaggio"
                fullWidth
                margin="normal"
                error={!!errors.capacita_stoccaggio}
                helperText={errors.capacita_stoccaggio?.message}
              />
            )}
          />
          <Controller
            defaultValue=""
            name="presenza_impianti_speciali"
            control={control}
            render={({ field }) => (
              <TextField
                select
                className="customTextBox"
                {...field}
                label="Impianti"
                fullWidth
                margin="normal"
                error={!!errors.presenza_impianti_speciali}
                helperText={errors.presenza_impianti_speciali?.message}
              >
                <MenuItem value={true}>Si</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </TextField>
            )}
          />
          <Controller
            defaultValue=""
            name="coordinate_gps"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                label="Coordinate Gps"
                fullWidth
                margin="normal"
                error={!!errors.coordinate_gps}
                helperText={errors.coordinate_gps?.message}
              />
            )}
          />
          <Controller
            defaultValue=""
            name="comune"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={cities?.map((cities) => cities.comune) || []}
                onChange={(event, value) => field.onChange(value)} // To handle selected value properly
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Comune"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.comune}
                    helperText={errors.comune?.message}
                  />
                )}
              />
            )}
          />

          <Grid container spacing={1}>
            <Grid size={4}>
              <Controller
                defaultValue=""
                name="cap"
                control={control}
                render={({ field }) => (
                  <TextField
                    className="customTextBox"
                    {...field}
                    label="CAP"
                    fullWidth
                    margin="normal"
                    error={!!errors.cap}
                    helperText={errors.cap?.message}
                  />
                )}
              />
            </Grid>
            <Grid size={3}>
              <Controller
                defaultValue=""
                name="provincia"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    options={provincies?.map((provincia) => provincia.provincia) || []}
                    onChange={(event, value) => field.onChange(value)} // To handle selected value properly
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="provincia"
                        className="customTextBox autoCompleteTextBox"
                        margin="normal"
                        fullWidth
                        error={!!errors.provincia}
                        helperText={errors.provincia?.message}
                      />
                    )}
                  />
                )}
              />
            </Grid>
            <Grid size={5}>
              <Controller
                defaultValue=""
                name="regione"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    options={regions?.map((regione) => regione.regione) || []}
                    onChange={(event, value) => field.onChange(value)} // To handle selected value properly
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Regione"
                        className="customTextBox autoCompleteTextBox"
                        margin="normal"
                        fullWidth
                        error={!!errors.regione}
                        helperText={errors.regione?.message}
                      />
                    )}
                  />
                )}
              />
            </Grid>
          </Grid>

          <Controller
            defaultValue=""
            name="note"
            control={control}
            render={({ field }) => <EmptyTextarea placeholder="Note" {...field} />}
          />

          <div className="btnPart1">
            <Button type="submit" variant="contained">
              Salva dati
            </Button>
          </div>
        </div>
      </form>
    </>
  );
};

export default StabilimentiForm;
